import { useEffect, useRef } from "react";

export function usePrevious(value) {
  let ref = useRef(value);
  useEffect(() => void (ref.current = value), [value]);
  return ref;
}
